export const textStyles = {
  content: {
    fontSize: "0.875rem",
    lineHeight: "133%",
    fontWeight: "normal",
    color: "gray.700"
  },
  contentLabel: {
    fontSize: "0.875rem",
    lineHeight: "133%",
    fontWeight: "normal",
    color: "gray.800"
  },
  footer: {
    fontSize: "0.75rem",
    lineHeight: "133%",
    fontWeight: "normal",
    letterSpacing: "0.2px",
    color: "gray.600"
  },
  error: {
    fontSize: "0.75rem",
    lineHeight: "133%",
    fontWeight: "normal",
    letterSpacing: "0.2px",
    color: "red.600"
  },
  label: {
    fontSize: "1.125rem",
    lineHeight: "123.5%",
    fontWeight: "medium",
    color: "gray.800"
  }
};

export const spacing = {
  // spacing between question main components title, content, footer
  question: 2,

  // spacing between answer options
  answerStack: 8,

  // spacing between label and answer option if any
  // for example Ranking question has label and answer option
  answerGroup: 2,

  // spacing between nested answer options
  // for example Likert question has nested answer options for each statement.
  answerBlock: 8,

  // spacing between footer items such as note, max note,error message
  footerStack: 2
};
